import { render, staticRenderFns } from "./FormattedDate.vue?vue&type=template&id=4e715e47"
import script from "./FormattedDate.vue?vue&type=script&lang=ts"
export * from "./FormattedDate.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports